import { CurrencyUtil, DateUtil, DisplayType, DisplayTypeUtil, NumberUtil } from "@mcleod/core";
import { AbstractInputParser } from "./AbstractInputParser";
import { TextboxValidator } from "./TextboxValidator";
import { ValidationResult } from "../../base/ValidationResult";

export class InputParser extends AbstractInputParser {
    dataSource: any;


    getDisplayValue(): string {
        return this.textbox.inputFormatter.formatText();
    }

    getDataValue() {
        if (DisplayTypeUtil.displaysDateOrTime(this.textbox.displayType, false)) {
            if (this.textbox.saveParamMode === true)
                return this.textbox.text;

            return DateUtil.parseDateByDisplayType(this.displayValue, this.textbox.displayType, this.textbox.timezone);
        }

        if (this.textbox.displayType === DisplayType.CURRENCY) {
            return parseFloat(CurrencyUtil.removeFormatting(this.displayValue));
        }
        else if (this.textbox.displayType === DisplayType.PERCENTAGE) {
            return this.displayValue.replace("%", "");
        }
        else if (DisplayTypeUtil.isDisplayTypeNumeric(this.textbox.displayType)) {
            return NumberUtil.getFloat(this.displayValue);
        }

        return this.displayValue;
    }

    validate(checkRequired: boolean, showErrors: boolean): ValidationResult {
        return TextboxValidator.validate(this.textbox, checkRequired, showErrors);
    }
}
